; (function () {
    var ua = navigator.userAgent;
    //ua = "Mozilla/5.0 (SMART-TV; X11; Linux armv7l) AppleWebKit/537.42 (KHTML, like Gecko) Chromium/25.0.1349.2 Chrome/25.0.1349.2 Safari/537.42";
    var browser = "", ver = "";
    if (/msie/i.test(ua)) {
        // ie < 11
        browser = "ie";
        ver = ua.match(/msie(.*?)[\;]/i)[1];
    } else if (/trident/i.test(ua)) {
        // ie 11
        browser = "ie";
        ver = ua.match(/rv:(.*?)[\s]/i)[1];
    } else if (/edge/i.test(ua)) {
        // edge
        browser = "edge";
        ver = ua.match(/edge\/(.*)?/i)[1];
    } else if (/opr|opera/i.test(ua)) {
        // opera
        browser = "opera";
        ver = window.opera ? window.opera.version() :
        /opr/i.test(ua) ? ua.match(/opr\/(.*)[\s]?/i)[1] : "";
    } else if (/firefox/i.test(ua)) {
        // firefox
        browser = "firefox";
        ver = ua.match(/firefox\/(.*)[\s]?/i)[1];
    } else if (/android/i.test(ua)) {
        // android
        browser = "android";
        ver = ua.match(/android\s(.*?)[\;]/i)[1];
    } else if (/chromium/i.test(ua)) {
        // chromium
        browser = "chromium";
        ver = ua.match(/chromium\/(.*?)[\s]/i)[1];
    } else if (/safari/i.test(ua) && !/chrome/i.test(ua)) {
        // safari
        browser = "safari";
        var _matches = ua.match(/version\/(.*?)[\s]/i);
        if (_matches && _matches.length >= 2) {
            ver = ua.match(/version\/(.*?)[\s]/i)[1];
        } else {
            ver = "-";
        }
    } else if (/chrome/i.test(ua)) {
        // chrome
        browser = "chrome";
        ver = ua.match(/chrome\/(.*?)[\s]/i)[1];
    } else {

    }
    var _html = document.querySelectorAll("html")[0];
    _html.setAttribute("browser", browser);
    if(ver != null) {
        _html.setAttribute("version", ver.split(".")[0]);
    }

})();